import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=34a48fc7&scoped=true"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a48fc7",
  null
  
)

export default component.exports